export const ReportFileExtension = {
  Excel: 'xlsx',
  PDF: 'pdf',
  PowerPoint: 'ppt',
} as const;

export type ReportFileExtensionType = typeof ReportFileExtension[keyof typeof ReportFileExtension];
